export default __webpack_public_path__ + "static/media/bitcoin.dc7b00b7.png";